var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export var defaultZIndex = 9999;
/* HOOK */
export function useZIndex(_a) {
    var _b = _a.initialValue, initialValue = _b === void 0 ? defaultZIndex : _b;
    var _c = React.useState(initialValue), value = _c[0], setValue = _c[1];
    var increment = function () { return setValue(value + 1); };
    return {
        increment: increment,
        value: value,
    };
}
/* DECORATOR */
export function withZIndex(config) {
    return function (Component) {
        return function WithZIndex(props) {
            return (React.createElement(Component, __assign({}, props, { zIndex: useZIndex(__assign(__assign({}, config), props.zIndex)) })));
        };
    };
}
/* RENDER PROP */
export function ZIndex(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var zIndex = useZIndex(props);
    return typeof children === 'function' ? children(zIndex) : children;
}
/* CONTEXT */
var noop = function (method) { return function () {
    return console.warn("Could not call `" + method + "`, please wrap your component in a `<ZIndexProvider>`");
}; };
export var ZIndexContext = React.createContext({
    increment: noop('increment'),
    value: defaultZIndex,
});
export function ZIndexProvider(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(ZIndexContext.Provider, { value: useZIndex(props) }, children));
}
export function useZIndexContext() {
    var ctx = React.useContext(ZIndexContext);
    ctx.value++;
    return ctx;
}
/**
 * @deprecated please use `useZIndexContext()`
 */
export var consumeZIndex = useZIndexContext;
//# sourceMappingURL=ZIndex.js.map